module.exports = __webpack_public_path__ + "static/media/uhn-transforming-the-or-supply-chain.6f599630.pdf";